import React, {useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../../components/modal/WizModal'
import WizButton from '../../../../components/button/WizButton'
import Text from '../../../../components/text/Text'
import {useString} from '../../../../utils/string'
import {createLeaderboardBanner} from '../../../../apis/banner/createLeaderboardBanner'
import useNavigation from '../../../../hooks/useNavigation'

interface IProps {
    className?: string
}

const AddBannerConfirmModal = ({className}: IProps, ref: any) => {
    const [body, setBody] = useState<any>()
    const modalRef = useRef<any>()
    const {shortCutString} = useString()
    const {goBanner} = useNavigation()

    useImperativeHandle(ref, () => ({
        show: data => {
            console.log(data)
            setBody(data)
            modalRef.current.show()
        },
    }))

    const createBanner = async () => {
        const result = await createLeaderboardBanner(body)

        if (result?.data) {
            alert('Create Complete Banner')
            goBanner()
        } else {
            alert('Create Error Banner')
        }
    }

    return (
        <>
            <WizModal title={'Confirm Banner Data'} className={`${className}`} ref={modalRef}>
                <div className={'space-y-[30px] text-center'}>
                    <Text>제작될 배너의 명세서는 아래와 같습니다.</Text>
                    <div className={'flex gap-x-[20px] justify-center'}>
                        <div>
                            <Text className={'text-font02'}>채널</Text>
                            <Text className={'text-ti1'}>{body?.language === 'ko' ? 'Korean' : 'English'}</Text>
                        </div>
                        <div>
                            <Text className={'text-font02'}>활성화</Text>
                            <Text className={`text-ti1 ${body?.is_active ? 'text-primary' : 'text-font_red'}`}>
                                {body?.is_active ? 'Show' : 'Hide'}
                            </Text>
                        </div>
                        <div>
                            <Text className={'text-font02'}>우선도</Text>
                            <Text className={'text-ti1'}>{body?.priority}</Text>
                        </div>
                    </div>
                    <div>
                        <Text className={'text-font02'}>배경색</Text>
                        <Text className={'text-ti1'}>{body?.background}</Text>
                    </div>
                    <div>
                        <Text className={'text-font02'}>배너 이미지</Text>
                        <a
                            href={body?.banner_image_pc}
                            target={'_blank'}
                            className={'underline text-alt_blue block'}
                            rel="noreferrer">
                            {shortCutString(body?.banner_image_pc, 20, 'end')}
                        </a>
                        <a
                            href={body?.banner_image_mo}
                            target={'_blank'}
                            className={'underline text-alt_blue block'}
                            rel="noreferrer">
                            {shortCutString(body?.banner_image_mo, 20, 'end')}
                        </a>
                    </div>
                    <div>
                        <Text className={'text-font02'}>SubTitle</Text>
                        <Text className={'text-ti1'}>
                            {body?.sub_title?.type === 'image' ? (
                                <a
                                    href={body?.sub_title?.image_url}
                                    target={'_blank'}
                                    className={'underline text-alt_blue'}
                                    rel="noreferrer">
                                    {shortCutString(body?.sub_title?.image_url, 20, 'end')}
                                </a>
                            ) : (
                                `${body?.sub_title?.text || '[None Data]'} / ${body?.sub_title?.color}`
                            )}
                        </Text>
                    </div>
                    <div>
                        <Text className={'text-font02'}>Title</Text>
                        <Text className={'text-ti1'}>
                            {body?.content?.image_pc ? (
                                body?.content?.image_mo ? (
                                    <>
                                        <a
                                            className={'underline text-alt_blue block'}
                                            href={body?.content?.image_pc}
                                            target={'_blank'}
                                            rel="noreferrer">
                                            PC: {shortCutString(body?.content?.image_pc, 20, 'end')}
                                        </a>
                                        <a
                                            className={'underline text-alt_blue block'}
                                            href={body?.content?.image_mo}
                                            target={'_blank'}
                                            rel="noreferrer">
                                            MO: {shortCutString(body?.content?.image_mo, 20, 'end')}
                                        </a>
                                    </>
                                ) : (
                                    '[Mobile Image 없음]'
                                )
                            ) : body?.content?.image_mo ? (
                                '[PC Image 없음]'
                            ) : (
                                `${body?.content?.title || '[None Data]'} /  ${body?.content?.title_color}`
                            )}
                        </Text>
                    </div>
                    <div className={'text-font02'}>
                        <Text className={'text-font02'}>Description</Text>
                        <Text className={'text-ti1'}>
                            {body?.content?.desc
                                ? `${body?.content?.desc} / ${body?.content?.desc_color}`
                                : '[None Data]'}
                        </Text>
                    </div>
                    <div>
                        <Text className={'text-font02'}>Button</Text>
                        {body?.button?.view ? (
                            <>
                                <Text className={'text-ti1'}>{body?.button?.text || '[None Data]'}</Text>
                                <Text className={'text-ti1'}>
                                    {(
                                        <a
                                            href={body?.button?.link}
                                            target={'_blank'}
                                            className={'underline text-alt_blue block'}
                                            rel="noreferrer">
                                            {shortCutString(body?.button?.link, 20, 'end')}
                                        </a>
                                    ) || '[None Link]'}
                                </Text>
                                <div className={'grid grid-cols-2 mt-[20px]'}>
                                    <Text className={'text-ti2'}>Border Color: {body?.button?.border_color}</Text>
                                    <Text className={'text-ti2'}>Text Color: {body?.button?.text_color}</Text>
                                    <Text className={'text-ti2'}>Bg Color: {body?.button?.background_color}</Text>
                                    <Text className={'text-ti2'}>
                                        Bg Color(hover): {body?.button?.hover_background_color}
                                    </Text>
                                </div>
                            </>
                        ) : (
                            <Text className={'text-ti1'}>[None Active Button]</Text>
                        )}
                    </div>
                </div>
                <div className={'text-center'}>
                    <WizButton
                        text={'Create Banner'}
                        className={'mt-[40px] '}
                        type={'blue'}
                        onClick={() => {
                            createBanner()
                        }}
                    />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(AddBannerConfirmModal)
